import React, { useEffect, useState } from 'react';
import "./PersonalHeader.scss"
import logo from '../../../images/staff_logo.svg'
import { useFetching } from '../../../hooks/useFetching';
import PostService from '../../../API/PostService';
import { setCurrentUserAction } from '../../../store/currentUserReducer';
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'universal-cookie';

const PersonalHeader = () => {
	const dispatch = useDispatch();
	const currentUser = useSelector(state => state.currentUser.currentUser);
	const personalData = useSelector(state => state.personal.personalData);
	const [user, setUser] = useState(null);

	const logout = async () => {
		fetchLogoutUser();
	}

	useEffect(() => {
		if (!currentUser) {
			fetchUserInfo();
		}
		setUser(currentUser);
	}, [currentUser])

	const [fetchUserInfo] = useFetching(async () => {
		const response = await PostService.getUserInfo()
		if (response.data.success && response.data.result !== false) {
			dispatch(setCurrentUserAction(response.data.result))
		}
	})

	const [fetchLogoutUser] = useFetching(async () => {
		const response = await PostService.logout()
		if (response.data.success && response.data.result !== false) {
			dispatch(setCurrentUserAction(null));
			const cookies = new Cookies(null, { path: '/' });
			cookies.remove('CRM-AUTH');
			window.location.reload();
		}
	})

	return (
		<div className="header">
			<div className="app-container--personal">
				<div className="header__inner">
					<div className="header__logo">
						<img src={logo} alt="" />
					</div>
					<div className="header__exit-btn">
						<button className='logout' onClick={logout}>
						</button>
					</div>
					<h1 className="header__title">
						{personalData?.name ?
							<>
								{personalData?.name + ', '}
								<span>{personalData?.position_id && personalData?.positions[personalData?.position_id[0]].name}</span>
							</> :
							<span>Сотрудник...</span>
						}
					</h1>
				</div>
			</div>
		</div>

	);
};

export default PersonalHeader;
